/**
 * One line of feedback, in the one place a phone user will see it.
 *
 * Errors are `role="alert"` so a screen reader says them without being asked, and
 * a retryable one gets the retry next to the sentence rather than in another
 * screen's footer.
 */

import type { ReactNode } from 'react';

export interface BannerProps {
  kind: 'error' | 'warning' | 'info' | 'success';
  children: ReactNode;
  onRetry?: () => void;
  retryLabel?: string;
}

export function Banner({ kind, children, onRetry, retryLabel = 'Try again' }: BannerProps) {
  return (
    <div className={`banner ${kind}`} role={kind === 'error' ? 'alert' : 'status'}>
      <span>{children}</span>
      {onRetry && (
        <button type="button" className="ghost" onClick={onRetry}>
          {retryLabel}
        </button>
      )}
    </div>
  );
}
